import DamagedPointsComponent from '@/common/components/adjusterReport/damagedPoints/DamagedPointsComponent';
import ImagePreviewDamagedPointsList from '@/common/components/adjusterReport/damagedPoints/ImagePreviewDamagedPointsList';
import PreviewImageAddDamagedPointModal from '@/common/components/adjusterReport/damagedPoints/PreviewImageAddDamagedPointModal';
import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="مقصر / تصاویر" header="titleHeader">
      <CulpritImagePreviewDamagedPoints />
    </MainLayout>
  );
};

const CulpritImagePreviewDamagedPoints = () => {
  const { closeModal, open, openModal } = useModal();
  const { culpritId } = useParams();

  return (
    <>
      <PreviewImageAddDamagedPointModal
        closeModal={closeModal}
        open={open}
        roleType="culprit"
        userId={+culpritId!}
      />{' '}
      <DamagedPointsComponent
        needSelectedPoints
        userType="culprit"
        header={
          <Box mt={24}>
            <Typography color="black-1" textStyle="b2">
              کارشناس محترم، در صورت داشتن نقاط آسیب‌دیده نسبت به ثبت آن اقدام
              نمایید؛ در غیر این صورت می‌توانید این مرحله را رد کنید.
            </Typography>
          </Box>
        }
        pointsList={
          <ImagePreviewDamagedPointsList
            participantRoleType="culprit"
            damaged_id={+culpritId!}
          />
        }
        buttons={
          <Box>
            <Button fullWidth mt={40} onClick={openModal}>
              تایید و ادامه
            </Button>
          </Box>
        }
      />
    </>
  );
};
